// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"gamesWrapper_btnWrapper__xenxH","info":"gamesWrapper_info__afUt3","btn":"gamesWrapper_btn__XOAMv"};